var Popover = function() {
    var getShowPopover = function(pid, scroll_to) {
        if ($('#' + pid + '_popover').length) {
            return;
        }
        Ajax.getPopover(pid, function(res) {
            if (res.success != 'ok') {
                return;
            }
            $('body').append(res.html);
            setTimeout(
                function() {
                    $('body').addClass('overlay-on');
                    $('.overlay').scrollTop(0);
                    if (scroll_to) {
                        $('.overlay').animate({
                            scrollTop: $(scroll_to).offset().top - $('.overlay').offset().top
                        }, 500);
                    }
                },
                100
            );
        });
    };
    var closePopover = function(transDelay) {
        $('body').removeClass('overlay-on');
        if (!$('.overlay').length) {
            return;
        }
        if (transDelay) { // use delay to apply transition effect
            setTimeout(
                function() {
                    $('.overlay').remove();
                },
                500
            );
        } else {
            $('.overlay').remove();
        }
    };
    return {
        init: function() {
            $('body').on('click', '.ii__popover_trigger', function() {
                var elem = $(this);
                var pid = elem.data('pid');
                var scroll_to = elem.data('scroll-to');
                if (!pid) {
                    return;
                }
                getShowPopover(pid, scroll_to);
            });
            $('#popover_close').click(function() {
                closePopover(true);
            });
        },
        refreshPopover: function(pid, scroll_to) {
            scroll_to = Util.defaultFor(scroll_to, false);
            closePopover(false);
            getShowPopover(pid, scroll_to);
        }
    };

}();
